/* eslint-disable react/prop-types */
import DeatilComponent from "./detail";
import { useState, useEffect } from "react";
import listsFile from "@/static-texts/lists.json";

const BENEFICIARY_PLACEHOLDER = "Seleziona i beneficiari";
const OUTGOINGS_PLACEHOLDER = "Seleziona le spese";
const TYPE_PLACEHOLDER = "Seleziona il tipo";
const SECTOR_PLACEHOLDER = "Seleziona il settore";
const INCENTIVE_PLACEHOLDER = "Seleziona istruttoria";

const { beneficiari, spese, type, settori, istruttoria } = listsFile;

function Deatil({ announcement, updateAnnouncement }) {
  const [isTechinaclFileInfoValid, setTechinaclFileInfoValid] = useState(
    announcement.technicalPDF
  );
  const [isMaxContributionValid, setMaxContributionValid] = useState(
    announcement.maxContribution
  );
  const [isNotesValid, setNotesValid] = useState(announcement.notes);
  const [isGrantedValid, setGrantedValid] = useState(announcement.granted);
  const [isPromotigValid, setPromotingValid] = useState(announcement.promoting);

  const [beneficiaries, setBeneficiaries] = useState(
    initializeList(beneficiari, announcement.beneficiary)
  );

  const [selectedBeneficiary, setSelectedBeneficiary] = useState(
    announcement.beneficiary
      ? announcement.beneficiary
      : BENEFICIARY_PLACEHOLDER
  );

  const [incentives, setIncentives] = useState(
    initializeSingleSelectionList(istruttoria, announcement.incentive)
  );
  const [selectedIncentive, setSelectedIncentive] = useState(
    announcement.incentive ? announcement.incentive : INCENTIVE_PLACEHOLDER
  );

  const [outgoings, setOutgoigs] = useState(
    initializeList(spese, announcement.outgoings)
  );
  const [selectedOutgoing, setSelectedOutgoing] = useState(
    announcement.outgoings ? announcement.outgoings : OUTGOINGS_PLACEHOLDER
  );

  const [types, setTypes] = useState(initializeList(type, announcement.types));
  const [selectedType, setSelecteType] = useState(
    announcement.types ? announcement.types : TYPE_PLACEHOLDER
  );

  const [sectors, setSectors] = useState(
    initializeList(settori, announcement.sector)
  );
  const [selectedSector, setSelecteSector] = useState(
    announcement.sector ? announcement.sector : SECTOR_PLACEHOLDER
  );

  const [techinaclFileInfo, setTechinaclFileInfo] = useState(
    announcement.technicalPDF ? announcement.technicalPDF : {}
  );

  useEffect(() => {
    const incentiveTarget = incentives.filter(
      ({ isSelected }) => isSelected === true
    );

    if (incentiveTarget?.length > 0) {
      setSelectedIncentive(incentiveTarget[0].name);
    } else {
      setSelectedIncentive(INCENTIVE_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incentives]);

  useEffect(() => {
    if (selectedIncentive !== INCENTIVE_PLACEHOLDER) {
      updateAnnouncement("incentive", selectedIncentive, announcement);
    } else {
      updateAnnouncement("incentive", "", announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIncentive]);

  useEffect(() => {
    if (techinaclFileInfo) {
      const { name, type, size, base64 } = techinaclFileInfo;
      if (name && type && size && base64) {
        updateAnnouncement(
          "technicalPDF",
          { name, type, size, base64 },
          announcement
        );
      }
      if (base64) {
        setTechinaclFileInfoValid(true);
      } else {
        setTechinaclFileInfoValid(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [techinaclFileInfo]);

  useEffect(() => {
    const beneficiaryTarget = beneficiaries.filter(
      ({ isSelected }) => isSelected === true
    );

    if (beneficiaryTarget?.length) {
      setSelectedBeneficiary(beneficiaryTarget);
    } else {
      setSelectedBeneficiary(BENEFICIARY_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beneficiaries]);

  useEffect(() => {
    if (selectedBeneficiary !== BENEFICIARY_PLACEHOLDER) {
      const list = toListOfNames(selectedBeneficiary);
      updateAnnouncement("beneficiary", list, announcement);
    } else {
      updateAnnouncement("beneficiary", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBeneficiary]);

  useEffect(() => {
    const outgoingTarget = outgoings.filter(
      ({ isSelected }) => isSelected === true
    );
    if (outgoingTarget?.length) {
      setSelectedOutgoing(outgoingTarget);
    } else {
      setSelectedOutgoing(OUTGOINGS_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outgoings]);

  useEffect(() => {
    if (selectedOutgoing !== OUTGOINGS_PLACEHOLDER) {
      const list = toListOfNames(selectedOutgoing);
      updateAnnouncement("outgoings", list, announcement);
    } else {
      updateAnnouncement("outgoings", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOutgoing]);

  useEffect(() => {
    const typeTarget = types.filter(({ isSelected }) => isSelected === true);
    if (typeTarget?.length) {
      setSelecteType(typeTarget);
    } else {
      setSelecteType(TYPE_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [types]);

  useEffect(() => {
    if (selectedType !== TYPE_PLACEHOLDER) {
      const list = toListOfNames(selectedType);
      updateAnnouncement("types", list, announcement);
    } else {
      updateAnnouncement("types", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedType]);

  useEffect(() => {
    const sectorTarget = sectors.filter(
      ({ isSelected }) => isSelected === true
    );
    if (sectorTarget?.length) {
      setSelecteSector(sectorTarget);
    } else {
      setSelecteSector(SECTOR_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectors]);

  useEffect(() => {
    if (selectedSector !== SECTOR_PLACEHOLDER) {
      const list = toListOfNames(selectedSector);
      updateAnnouncement("sector", list, announcement);
    } else {
      updateAnnouncement("sector", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSector]);

  const handleBeneficiarySelect = ({ name }) => {
    setBeneficiaries(updateMuliChoiceList(name, beneficiaries));
  };

  const handleOutgoingSelect = ({ name }) => {
    setOutgoigs(updateMuliChoiceList(name, outgoings));
  };

  const handleTypeSelect = ({ name }) => {
    setTypes(updateMuliChoiceList(name, types));
  };

  const handlePromotingChange = (e) => {
    updateAnnouncement("promoting", e.target.value, announcement);

    if (e.target.value) {
      setPromotingValid(true);
    } else {
      setPromotingValid(false);
    }
  };

  const handleGrantedChange = (e) => {
    updateAnnouncement("granted", e.target.value, announcement);
    if (e.target.value) {
      setGrantedValid(true);
    } else {
      setGrantedValid(false);
    }
  };

  const handleNotesChange = (e) => {
    updateAnnouncement("notes", e.target.value, announcement);
    if (e.target.value) {
      setNotesValid(true);
    } else {
      setNotesValid(false);
    }
  };

  async function handleTechnicalDocumentUpload(event) {
    const [file] = event.target.files;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var base64;
      if (reader?.result) {
        base64 = reader?.result.split(",")[1];
      }
      setTechinaclFileInfo({
        name: file.name,
        type: file.type,
        size: Math.round(file.size / 1000) + " kB",
        base64: base64,
        file: file,
      });
    };
  }

  const handleIncentiveSelect = ({ name }) => {
    setIncentives(updateIncentives({ name, incentives }));
  };

  const handleSectorSelect = ({ name }) => {
    setSectors(updateMuliChoiceList(name, sectors));
  };

  const handleMaxContributionChange = (e) => {
    updateAnnouncement("maxContribution", e.target.value, announcement);

    if (e.target.value) {
      setMaxContributionValid(true);
    } else {
      setMaxContributionValid(false);
    }
  };

  return (
    <DeatilComponent
      beneficiaries={beneficiaries}
      selectedBeneficiary={selectedBeneficiary}
      onBeneficiarySelect={handleBeneficiarySelect}
      outgoings={outgoings}
      selectedOutgoing={selectedOutgoing}
      onOutgoingSelect={handleOutgoingSelect}
      types={types}
      selectedType={selectedType}
      onTypeSelect={handleTypeSelect}
      onPromotingChange={handlePromotingChange}
      onGrantedChange={handleGrantedChange}
      onNotesChange={handleNotesChange}
      sectors={sectors}
      selectedSector={selectedSector}
      onSectorSelect={handleSectorSelect}
      onMaxContributionChange={handleMaxContributionChange}
      onTechnicalDocumentUpload={handleTechnicalDocumentUpload}
      isTechinaclFileInfoValid={isTechinaclFileInfoValid}
      techinaclFileInfo={techinaclFileInfo}
      isBeneficiaryValid={selectedBeneficiary !== BENEFICIARY_PLACEHOLDER}
      isOutgoingsValid={selectedOutgoing !== OUTGOINGS_PLACEHOLDER}
      isTypeValid={selectedType !== TYPE_PLACEHOLDER}
      isSectorValid={selectedSector !== SECTOR_PLACEHOLDER}
      isMaxContributionValid={isMaxContributionValid}
      isNotesValid={isNotesValid}
      isGrantedValid={isGrantedValid}
      isPromotigValid={isPromotigValid}
      isIncentiveValid={selectedIncentive !== INCENTIVE_PLACEHOLDER}
      onIncentiveSelect={handleIncentiveSelect}
      selectedIncentive={selectedIncentive}
      incentives={incentives}
      announcement={announcement}
    />
  );
}

/*function updateList(name, list) {
  return list.map((obj) => {
    return {
      ...obj,
      isSelected: obj.name === name,
    };
  });
}*/

function updateIncentives({ name, incentives }) {
  return incentives.map((incentive) => {
    return {
      ...incentive,
      isSelected: incentive.name === name ? !incentive.isSelected : false,
    };
  });
}

function initializeList(list, selectedNames) {
  return list.map((object) => {
    const found = selectedNames?.find((name) => name === object.name);

    return {
      ...object,
      isSelected: found !== undefined,
    };
  });
}

function initializeSingleSelectionList(list, selectedName) {
  return list.map((object) => {
    return {
      ...object,
      isSelected: object.name === selectedName,
    };
  });
}

function updateMuliChoiceList(name, list) {
  return list.map((obj) => {
    return {
      ...obj,
      isSelected: obj.name === name ? !obj.isSelected : obj.isSelected,
    };
  });
}

function toListOfNames(list) {
  return list.map(({ name }) => {
    return name;
  });
}
export default Deatil;
